<template>
  <div class="checkin-wrap">
    <div class="checkin-header">
      <div class="header-image-wrapper">
        <div class="header-image-bg appHeader">
          <img :src="`${(data.branding || {}).logoUrl || '/timecloud-logo-white.png'}`" />
        </div>
      </div>
    </div>
    <h2 style="padding-top:40px;">Important! - Site Check In</h2>
    <h2 style="padding-top:20px;">All Visitors must sign in</h2>
    <img
      style="margin-top:10px;margin-bottom:10px;max-width:350px;margin-left:auto;margin-right:auto;"
      :src="`${baseURL}locations/${data.code}/qr?type=svg` | encode"
      alt="QR Code"
    />
    <h4 style="padding-top:10px;padding-bottom:10px;">Or Visit</h4>
    <h2 style="padding-bottom:40px;">{{hostname}}{{data.code}}</h2>
    <div class="checkin-footer">
      <div class="powered">
        <p>Powered by</p>
        <a target="_blank" href="https://jointimecloud.com/">
          <img src="/timecloud-logo.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { baseURL, hostname } from '@/axios.js';
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      baseURL,
      hostname
    }
  }
}
</script>